import { View } from './view.js';

class GridView extends View {
	_parentElement = document.querySelector('.main-letters');

	_generateMarkUp() {
		this._parentElement = document.querySelector('.main-letters');

		console.log('this:', this);
		return this._pageData.data.map(this._generateMarkUpPreview).join('');
	}

	_generateMarkUpPreview(item) {
		return ` 
		<div class="letter-box">
			<img class="letter-box__img" src="${item.imgfilename}" alt="${item.title}">
			<div class="letter-box__data">
				<h2 class="letter-box__title">${item.title}</h2>
				<p class="letter-box__desc">${item.desc}</p>
				<a  class="letter-box__display" 
				href="#${item.id}">عرض</a>
			</div>
		</div>`;
	}
	//Handle Events through Publisher-Subscriber Pattern
	addhandlerRendrer(handler) {
		['hashchange', 'load'].forEach((ev) =>
			window.addEventListener(ev, handler)
		);
	}
}

export default new GridView();

//This is the function to populate the html page with the data of the letters
//each letter has an image, title, desc, and a pdf file name.
// render(pageData) {
// 	this.#pageData = pageData;

// 	//1. clear parent element
// 	this.#clear();

// 	this.#pageData.data.forEach((letter) => {
// 		const html = `
// <div class="letter-box">
//     <img class="letter-box__img" src="${
// 			this.#pageData.folderPath + letter.imgfilename
// 		}" alt="${letter.title}">
//     <div class="letter-box__data">
//         <h2 class="letter-box__title">${letter.title}</h2>
//         <p class="letter-box__desc">${letter.desc}</p>
//         <a  class="letter-box__display"
// 		href="#${letter.id}">عرض</a>
//     </div>
// </div>`;
// 		this.#parentElement.insertAdjacentHTML('beforeend', html);
// 	});
// }
